import { UnitSimOperation } from "@/store/flowsheet/flowsheet.slice"
import { Edge, useGraphInstance } from "@antv/xflow"
import { useEffect, useRef } from "react"
import { LineType } from "../../constant"
import { statusToCellColor, toCellSimStatus, CellSimStatus } from "./CellsSimHooks"

export const StreamsUpdatePlugin = ({cellMap}: {cellMap: {[key: string]: UnitSimOperation}}) => {
  const graph = useGraphInstance();
  const graphRef = useRef(graph)
  graphRef.current = graph;

  useEffect(() => {
    if (!graph) return;
    const streams = graph.getEdges()
    .filter(item => item.data.type === LineType.FlowLine && !item.data.hide)
    streams.forEach(item => {
      const streamId = item.data.streamId || item.id;
      const simState = cellMap[streamId]
      if (!simState) {
        return;
      }
      const color = statusToCellColor(toCellSimStatus(simState.status))
      item.attr('line/stroke', color)
    })
    
  }, [graph, cellMap])

  useEffect(() => {
    const defaultColor = statusToCellColor(CellSimStatus.Unknow)
    return () => {
      const curGraph = graphRef.current;
      if (!curGraph) return;
      curGraph.getEdges()
        .filter(item => item.data.type === LineType.FlowLine && !item.data.hide)
        .forEach((item: Edge) => {
          const itemColor = item.getAttrByPath('line/stroke')
          if (itemColor !== defaultColor) {
            item.attr('line/stroke', defaultColor)
          }
        })
    }    
  }, [])

  return null;
}